<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span>{{ title }}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{ iconname }}</mat-icon>
    </h1>
    <div class="centerwrap scroll" fxFlex.gt-sm="auto">
        <div [innerHTML]="message | safeHTML"></div>
        <mat-form-field floatLabel="never" class="fullwidth">
            <mat-select [(ngModel)]="selection" placeholder="Select choice...">
                <mat-option>{{ placeholder }}</mat-option>
                <mat-option *ngFor="let opt of options" [value]="opt.Value">{{ opt.Text }}</mat-option>
            </mat-select>
        </mat-form-field>
        <div *ngIf="textprefix" [innerHTML]="textprefix"></div>
        <mat-form-field appearance="outline" floatLabel="never" class="fullwidth">
            <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="4"
                [(ngModel)]="comments"
                placeholder="Enter text here..."
            ></textarea>
        </mat-form-field>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center center"
        fxLayoutGap.lt-md="10px"
    >
        <button mat-raised-button color="warn" (click)="CancelHandler()">{{ canceltext }}</button>
        <button mat-raised-button color="primary" (click)="OKHandler()" [disabled]="!selection">{{ oktext }}</button>
    </div>
</div>
